import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../../utils/helpers';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, icon, className, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-xs font-semibold text-[#94a3b8] mb-1.5 uppercase tracking-wider">
            {label}
          </label>
        )}
        <div className="relative">
          {icon && (
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-[#64748b]">
              {icon}
            </div>
          )}
          <input
            ref={ref}
            className={cn(
              'w-full bg-[#0f0f1a] border border-[#252535] rounded-xl text-[#f1f5f9] placeholder-[#64748b] text-sm',
              'transition-all duration-200 input-focus',
              icon ? 'pl-10' : 'pl-3',
              'pr-3 py-2.5',
              error && 'border-[#ef4444] focus:border-[#ef4444] focus:ring-[#ef4444]',
              className
            )}
            {...props}
          />
        </div>
        {error && <p className="mt-1.5 text-sm text-[#ef4444]">{error}</p>}
      </div>
    );
  }
);

Input.displayName = 'Input';
